(() => {
  const root = document.querySelector('[data-welcome-offer]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const KEY = 'muaazon_welcome_offer_state_v5';
  const DISMISS_DAYS = 14;
  const CAPTURE_DAYS = 90;
  const APPLY_DAYS = 30;
  const OFFER_CODE = root.dataset.offerCode || 'MUAAZON10';
  const params = new URLSearchParams(window.location.search);
  const isPreview = Boolean(window.Shopify?.designMode)
    || params.has('preview_theme_id')
    || params.has('welcome_offer')
    || window.location.hostname.includes('shopifypreview.com');
  const forceParam = params.get('welcome_offer') === '1' || params.get('welcome_offer') === 'true';
  /* Entry popup: show shortly after arrival (faster in preview / forced) */
  const delay = forceParam ? 400 : (isPreview ? 1200 : 3500);

  let previousFocus = null;
  let previousHtmlOverflow = '';
  let previousBodyOverflow = '';
  let previousBodyOverscroll = '';
  let shownThisPage = false;
  let currentSource = root.dataset.defaultSource || 'welcome';
  let currentTrigger = 'timer';
  let currentStep = 'email';

  const COPY = {
    welcome: [
      root.dataset.welcomeHeading || 'Get <strong>10% Off</strong> Your First Order',
      root.dataset.welcomeLead || 'Join for your welcome code, home-organization ideas, new arrivals, and special offers.',
    ],
    wishlist: [
      'Take <em>10% Off</em> your wishlist picks',
      'Join by email and unlock your welcome offer on the products you’re considering.',
    ],
    cart: [
      'Take <em>10% Off</em> your cart',
      'Join by email and unlock your welcome offer before checkout.',
    ],
  };
  const TAGS = {
    welcome: 'newsletter, Phase 3 Lead, Lead - Welcome, MUAAZON10, email',
    wishlist: 'newsletter, Phase 3 Lead, Lead - Wishlist, MUAAZON10, email',
    cart: 'newsletter, Phase 3 Lead, Lead - Cart, MUAAZON10, email',
  };

  const readState = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (_) { return {}; } };
  const writeState = (state) => { if (isPreview && !forceParam) return; try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {} };
  const cartCount = () => Number.parseInt(document.querySelector('[data-cart-root]')?.dataset?.itemCount || '0', 10) || 0;
  const wishlistCount = () => {
    try {
      const value = JSON.parse(localStorage.getItem('muaazon:wishlist:v1') || '[]');
      return Array.isArray(value) ? value.length : 0;
    } catch (_) { return 0; }
  };
  const detail = (source = currentSource, trigger = currentTrigger) => ({
    source, trigger, offerCode: OFFER_CODE, cartCount: cartCount(), wishlistCount: wishlistCount(),
  });
  const emit = (name, source = currentSource, trigger = currentTrigger) => {
    document.dispatchEvent(new CustomEvent(name, { detail: detail(source, trigger) }));
  };

  const suppressed = () => {
    // Opt-in draft QA switch: ?muaazon_qa=1 leaves the customer offer unchanged.
    if (params.get('muaazon_qa') === '1' && !forceParam) return true;
    if (forceParam) return false;
    if (isPreview) return false;
    const state = readState();
    const now = Date.now();
    if (state.capturedAt && now - state.capturedAt < CAPTURE_DAYS * 86400000) return true;
    if (state.appliedAt && now - state.appliedAt < APPLY_DAYS * 86400000) return true;
    if (state.dismissedAt && now - state.dismissedAt < DISMISS_DAYS * 86400000) return true;
    return false;
  };

  const isMobileLayout = () => window.matchMedia('(max-width: 819.98px)').matches;

  const setSource = (source) => {
    const next = COPY[source] ? source : 'welcome';
    currentSource = next;
    const heading = root.querySelector('[data-welcome-offer-heading]');
    const lead = root.querySelector('[data-welcome-offer-lead]');
    const tags = root.querySelector('[data-lead-tags]');
    if (heading) heading.innerHTML = COPY[next][0];
    if (lead) lead.textContent = COPY[next][1];
    if (tags) tags.value = TAGS[next];
  };

  const syncNote = () => {
    const note = root.querySelector('[data-welcome-offer-note]');
    const phone = (
      root.querySelector('[data-welcome-offer-phone-step]')?.value
      || root.querySelector('[data-welcome-offer-phone]')?.value
      || ''
    ).trim();
    if (note) note.value = phone ? `SMS welcome offer phone: ${phone}` : '';
  };

  const setStep = (step) => {
    currentStep = step;
    root.dataset.step = step;
    const emailStep = root.querySelector('[data-welcome-step="email"]');
    const smsStep = root.querySelector('[data-welcome-step="sms"]');
    const back = root.querySelector('[data-welcome-offer-back]');
    if (emailStep) {
      emailStep.hidden = step !== 'email';
      emailStep.classList.toggle('is-active', step === 'email');
    }
    if (smsStep) {
      smsStep.hidden = step !== 'sms';
      smsStep.classList.toggle('is-active', step === 'sms');
    }
    if (back) back.hidden = !(isMobileLayout() && step === 'sms');
    const focusTarget = step === 'sms'
      ? root.querySelector('[data-welcome-offer-phone-step]')
      : root.querySelector('[data-welcome-offer-email]');
    window.setTimeout(() => focusTarget?.focus?.(), 20);
  };

  const preferredSource = () => (wishlistCount() > 0 ? 'wishlist' : (cartCount() > 0 ? 'cart' : 'welcome'));
  const focusables = () => [...root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')]
    .filter((el) => !el.hidden && el.getAttribute('type') !== 'hidden' && el.getClientRects().length > 0);

  const lockPage = () => {
    previousHtmlOverflow = document.documentElement.style.overflow;
    previousBodyOverflow = document.body.style.overflow;
    previousBodyOverscroll = document.body.style.overscrollBehavior;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.overscrollBehavior = 'none';
  };
  const unlockPage = () => {
    document.documentElement.style.overflow = previousHtmlOverflow;
    document.body.style.overflow = previousBodyOverflow;
    document.body.style.overscrollBehavior = previousBodyOverscroll;
  };

  const show = ({ source = preferredSource(), trigger = 'timer', force = false } = {}) => {
    if ((!force && suppressed()) || (!force && shownThisPage) || !root.hidden) return;
    const shoppingDialog = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')]
      .some((dialog) => !root.contains(dialog) && dialog.getClientRects().length > 0);
    if (shoppingDialog && !force) return;
    setSource(source);
    currentTrigger = trigger;
    previousFocus = document.activeElement;
    setStep('email');
    root.hidden = false;
    shownThisPage = true;
    lockPage();
    root.querySelector('[data-welcome-offer-success], [data-welcome-offer-error-state], [data-welcome-offer-email], [data-welcome-offer-dialog]')?.focus?.();
    emit('theme:lead-capture:view');
  };

  const close = (remember = true) => {
    if (root.hidden) return;
    root.hidden = true;
    unlockPage();
    if (remember) writeState({ ...readState(), dismissedAt: Date.now() });
    emit('theme:lead-capture:dismiss');
    previousFocus?.focus?.();
  };

  root.querySelectorAll('[data-welcome-offer-close]').forEach((el) => {
    el.addEventListener('click', () => close(true));
  });
  root.querySelector('[data-welcome-offer-back]')?.addEventListener('click', () => setStep('email'));
  root.querySelector('[data-welcome-offer-apply]')?.addEventListener('click', () => {
    writeState({ ...readState(), appliedAt: Date.now() });
  });
  root.querySelector('[data-welcome-offer-copy]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    const code = button.dataset.code || OFFER_CODE;
    try {
      await navigator.clipboard.writeText(code);
      button.textContent = 'Copied';
      window.setTimeout(() => { if (button.isConnected) button.textContent = 'Copy code'; }, 1800);
    } catch (_) {}
  });

  const form = root.querySelector('#WelcomeOfferClaimForm');
  const emailInput = root.querySelector('[data-welcome-offer-email]');
  const phoneDesktop = root.querySelector('[data-welcome-offer-phone]');
  const phoneStep = root.querySelector('[data-welcome-offer-phone-step]');

  root.querySelector('[data-welcome-offer-email-next]')?.addEventListener('click', () => {
    if (!emailInput?.checkValidity()) {
      emailInput?.reportValidity?.();
      return;
    }
    if (isMobileLayout()) {
      setStep('sms');
      return;
    }
    syncNote();
    form?.requestSubmit?.();
  });

  const armSubmit = (button) => {
    if (!button) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Unlocking offer…';
  };

  form?.addEventListener('submit', (event) => {
    if (!form.checkValidity()) {
      event.preventDefault();
      return;
    }
    if (phoneStep && phoneDesktop && currentStep === 'sms' && phoneStep.value && !phoneDesktop.value) {
      phoneDesktop.value = phoneStep.value;
    }
    syncNote();
    writeState({
      ...readState(),
      pendingSource: currentSource,
      pendingTrigger: currentTrigger,
      submittedAt: Date.now(),
    });
    emit('theme:lead-capture:submit');
    armSubmit(root.querySelector('[data-welcome-offer-submit]:not([hidden])')
      || root.querySelector('[data-welcome-offer-submit-sms]')
      || root.querySelector('[data-welcome-offer-submit]'));
  });

  root.querySelector('[data-welcome-offer-skip-sms]')?.addEventListener('click', () => {
    if (phoneStep) phoneStep.value = '';
    syncNote();
  });

  document.addEventListener('submit', (event) => {
    const newsletter = event.target?.closest?.('.marketplace-newsletter__form');
    if (!newsletter || !newsletter.checkValidity()) return;
    document.dispatchEvent(new CustomEvent('theme:lead-capture:submit', {
      detail: { source: 'newsletter', trigger: 'newsletter', offerCode: '', cartCount: cartCount(), wishlistCount: wishlistCount() },
    }));
  });

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      close(true);
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  const state = readState();
  const hasSuccess = Boolean(root.querySelector('[data-welcome-offer-success]'));
  const hasError = Boolean(root.querySelector('[data-welcome-offer-error-state]'));
  if (hasSuccess) {
    setSource(state.pendingSource || 'welcome');
    currentTrigger = state.pendingTrigger || 'form_response';
    writeState({ ...state, capturedAt: Date.now(), pendingSource: null, pendingTrigger: null });
    emit('theme:lead-capture:success');
    window.setTimeout(() => show({ source: currentSource, trigger: currentTrigger, force: true }), 0);
  } else if (hasError) {
    window.setTimeout(() => show({
      source: state.pendingSource || preferredSource(),
      trigger: state.pendingTrigger || 'form_error',
      force: true,
    }), 0);
  } else {
    window.setTimeout(() => show({ source: preferredSource(), trigger: 'entry' }), delay);
  }

  const newsletterSuccess = document.querySelector('[data-lead-capture-success="newsletter"]');
  if (newsletterSuccess) {
    document.dispatchEvent(new CustomEvent('theme:lead-capture:success', {
      detail: { source: 'newsletter', trigger: 'newsletter', offerCode: '', cartCount: cartCount(), wishlistCount: wishlistCount() },
    }));
  }

  if (window.matchMedia?.('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', (event) => {
      if (event.relatedTarget || event.clientY > 0) return;
      show({ source: preferredSource(), trigger: 'exit_intent' });
    }, { passive: true });
  }

  let scrollChecked = false;
  window.addEventListener('scroll', () => {
    if (scrollChecked) return;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= 0.55) {
      scrollChecked = true;
      show({ source: preferredSource(), trigger: 'scroll_55' });
    }
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const toggle = event.target?.closest?.('[data-saved-product-toggle][data-saved-list="wishlist"]');
    if (!toggle) return;
    window.setTimeout(() => {
      if (toggle.getAttribute('aria-pressed') === 'true' && wishlistCount() > 0) {
        show({ source: 'wishlist', trigger: 'wishlist_save' });
      }
    }, 150);
  });

  window.addEventListener('resize', () => {
    if (!isMobileLayout() && currentStep === 'sms') setStep('email');
    const back = root.querySelector('[data-welcome-offer-back]');
    if (back) back.hidden = !(isMobileLayout() && currentStep === 'sms');
  });
})();
